declare global {
    interface Window {
        gtag?: (event: string, eventName: string, eventParams: { [key: string]: unknown }) => void;
    }
}

export const trackEvent = (action: string, params?: { [key: string]: any }) => {
    if (window.gtag) {
        window.gtag("event", action, params ?? {});
    }
};

let startTime: number;

export const eventStartGame = (player_count: number) => {
    startTime = Date.now();
    if (window.gtag) {
        window.gtag("event", "game_start", {
            game_title: "Chess",
            player_count: player_count,
        });
    }
};

export const eventEndGame = (player_count: number) => {
    if (window.gtag) {
        window.gtag("event", "game_end", {
            game_title: "Chess",
            player_count: player_count,
        });
        if (typeof startTime === "number" && !isNaN(startTime)) {
            eventPlayTime();
        }
    }
};

export const eventQuitGame = () => {
    if (window.gtag) {
        window.gtag("event", "game_quit", {
            game_title: "Chess",
        });
    }
};

const eventPlayTime = () => {
    const playTime = Math.round((Date.now() - startTime) / 1000);
    if (window.gtag) {
        window.gtag("event", "play_time", {
            game_title: "Chess",
            play_time: playTime,
        });
    }
};
